

var validate = {
  /* 验证重复密码一致*/
  isRepeat: function (password,repeatPassword){
    if(password != repeatPassword){
      return false;
    }else{
      return true;
    }
  },
  /* 验证密码*/
  password: function (str){
    if(str.length > 5 && str.length < 26){
      return true;
    }else{
      return false;
    }
  },
  /* 是否是空*/
  isNull: function (str){
    if(str.trim() == null || str.trim() == ''){
      return false;
    }else{
      return true;
    }
  },
  /* 是否是邮箱*/
  isEmail: function (str){
    const reg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
    return reg.test(str);
  },

  /* 是否是手机号码*/
  isPhone: function (str){
    const reg = /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/;
    return reg.test(str);
  },

  getNowFormatDate: function(){
    var date = new Date();
    var seperator1 = "-";
    var seperator2 = ":";
    var month = date.getMonth() + 1;
    var minutes = date.getMinutes();
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (minutes >= 1 && minutes <= 9) {
      minutes = "0" + minutes;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate
      + " " + date.getHours() + seperator2 + minutes
      + seperator2 + date.getSeconds();
    return currentdate;
  },
  GetDateDiff:function (startDate,endDate) {
    var startTime = new Date(Date.parse(startDate.replace(/-/g,   "/"))).getTime();
    var endTime = new Date(Date.parse(endDate.replace(/-/g,   "/"))).getTime();
    var dates = Math.abs((startTime - endTime))/(1000*60*60*24);
    dates = parseInt(dates)
    return  dates;
  },
  isWeiXin:function () {
    //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
    var ua = window.navigator.userAgent.toLowerCase();
    //通过正则表达式匹配ua中是否含有MicroMessenger字符串
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true;
    } else {
      return false;
    }
  },
  is_qq:function () {
    var ua = navigator.userAgent.toLowerCase();
    if(ua.match(/QQ/i) == "qq") {
      return true;
    }
    return false;
  },
  is_dingding:function () {
    var ua = navigator.userAgent.toLowerCase();
    return ua.indexOf("dingtalk") >= 0;
  }
}
export default validate




/*var validateNickName = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入昵称'));
  } else {
    callback();
  }
};
var validateCode = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入验证码'));
  } else {
    callback();
  }
};*/
/*var validatePhone = (rule, value, callback) => {
  if (!/^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\\d{8}$/.test(value)) {
    if(!/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/.test(value)){
      callback(new Error('邮箱地址格式不正确'));
    }
    callback(new Error('手机号码格式不正确'));
  }else{
    callback();
  }
};
var validatePassword = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入密码'));
  } else if(value.length() < 6 || value.length() > 25){
    callback(new Error('请输入密码（6-25位，数字和字母均可）'));
  }else{
    if (this.ruleForm2.repeatPassword !== '') {
      this.$refs.ruleForm2.validateField('repeatPassword');
    }
    callback();
  }
};
var validateRepeatPassword = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请再次输入密码'));
  } else if (value !== this.ruleForm2.repeatPassword) {
    callback(new Error('两次输入密码不一致!'));
  } else {
    callback();
  }
};*/






// WEBPACK FOOTER //
// ./src/utils/validate.js